import React, { useEffect, useState } from "react";
import StatusBadge from "./StatusBadge";
import { enrichPadronCallable } from "../utils/habiApi";
import { colors, spacing, typography } from "../utils/designTokens";

/**
 * Badge de datos públicos para un padrón: régimen PH (común / en trámite /
 * incorporado) + Vivienda Promovida (Ley 18.795) con desarrollador. Consulta la
 * callable `enrichPadron` con debounce. Falla en silencio (no muestra nada) si la
 * function no está desplegada o el padrón no existe en el parcelario IM.
 */
export default function VisBadge({ padron }) {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const p = Number(padron);
    if (!p) { setInfo(null); return; }
    let alive = true;
    setLoading(true);
    const t = setTimeout(() => {
      enrichPadronCallable({ padron: p })
        .then((e) => { if (alive) setInfo(e); })
        .catch(() => { if (alive) setInfo(null); })
        .finally(() => { if (alive) setLoading(false); });
    }, 800);
    return () => { alive = false; clearTimeout(t); };
  }, [padron]);

  if (!padron) return null;
  if (loading) return <span style={{ fontSize: typography.sizes.xs, color: colors.gray400 }}>Consultando datos públicos…</span>;
  if (!info) return null;

  const vis = info.viviendaPromovida && info.viviendaPromovida.vis;
  const obra = vis ? info.viviendaPromovida.obra : null;
  return (
    <div style={{ display: "flex", gap: spacing[1], flexWrap: "wrap", marginTop: spacing[1], alignItems: "center" }}>
      <StatusBadge status={info.estadoPH} size="sm" />
      {vis && <StatusBadge status="vivienda_promovida" label="Vivienda Promovida (Ley 18.795)" size="sm" />}
      {obra && obra.empresa && (
        <span style={{ fontSize: typography.sizes.xs, color: "#6b21a8" }}>
          {obra.empresa}{obra.totalViviendas ? ` · ${obra.totalViviendas} viv.` : ""}
        </span>
      )}
    </div>
  );
}
